<cdk-virtual-scroll-viewport itemSize="75" [ngClass]="{ big: controlArray.controls.length > 20 }">
  <table>
    <thead>
      <tr>
        @if (counterEnabled) {
          <th class="desktop"></th>
        }
        <th>{{ 'global.email' | transloco }}*</th>
        <th>{{ 'global.first_name' | transloco }}</th>
        <th>{{ 'global.surname' | transloco }}</th>
        <th>{{ 'global.language' | transloco }}</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *cdkVirtualFor="let controlGroup of controlArray.controls; let i = index"
        [formGroup]="controlGroup | formGroup"
        class="respondent-form"
      >
        @if (counterEnabled) {
          <td class="desktop">
            <span>{{ i + 1 }}</span>
          </td>
        }
        <td>
          <mat-form-field [floatLabel]="showLabels" [hideRequiredMarker]="true">
            <mat-label>
              <span [class.required-label]="isRequired(controlGroup.get('email'))">{{
                'global.email' | transloco
              }}</span>
            </mat-label>
            <input
              class="red-err-bg"
              #emailInput
              [formControl]="controlGroup.get('email') | formControl"
              matInput
              placeholder=" "
            />
            @if (controlGroup.get('email').errors && controlGroup.get('email').dirty) {
              <mat-error>{{ 'form.error.invalid_email' | transloco }} </mat-error>
            }
            @if (duplicatedRespondents?.includes(controlGroup.get('email').value)) {
              <span class="warning form-field-warning">{{ 'research_groups.duplicated_email' | transloco }}</span>
            }
          </mat-form-field>
        </td>
        <td>
          <mat-form-field [floatLabel]="showLabels" [hideRequiredMarker]="true">
            <mat-label>
              <span [class.required-label]="isRequired(controlGroup.get('first_name'))">{{
                'global.first_name' | transloco
              }}</span>
            </mat-label>
            <input
              class="red-err-bg"
              [formControl]="controlGroup.get('first_name') | formControl"
              matInput
              placeholder=" "
            />
            @if (controlGroup.get('first_name').errors?.['pattern'] && controlGroup.get('first_name').dirty) {
              <mat-error>{{ 'form.error.use_only_latin_alphabet' | transloco }}</mat-error>
            }
          </mat-form-field>
        </td>
        <td>
          <mat-form-field [floatLabel]="showLabels" [hideRequiredMarker]="true">
            <mat-label>
              <span [class.required-label]="isRequired(controlGroup.get('last_name'))">{{
                'global.surname' | transloco
              }}</span>
            </mat-label>
            <input
              class="red-err-bg"
              [formControl]="controlGroup.get('last_name') | formControl"
              matInput
              placeholder=" "
            />
            @if (controlGroup.get('last_name').errors?.['pattern'] && controlGroup.get('last_name').dirty) {
              <mat-error>{{ 'form.error.use_only_latin_alphabet' | transloco }}</mat-error>
            }
          </mat-form-field>
        </td>
        <td>
          <lib-select
            class="lang-select"
            [options]="langOptions"
            [noBackground]="true"
            [noUnderline]="false"
            [offsetToLeft]="true"
            [value]="controlGroup.get('language').value"
            (valueChange)="controlGroup.patchValue({ language: $event })"
            [errors]="controlGroup.get('language').errors"
          ></lib-select>
          @if (controlGroup.get('language').errors && controlGroup.get('language').dirty) {
            <mat-error class="invalid-value">{{ 'form.error.invalid_value' | transloco }} </mat-error>
          }
        </td>
        <td>
          <span
            (click)="handleTrashClick(controlGroup)"
            class="icon icon-trash ml-2"
            [inlineSVG]="deleteIconPath ? deleteIconPath : '/icons/icon-trash-v2.svg'"
          ></span>
        </td>
      </tr>
    </tbody>
  </table>
</cdk-virtual-scroll-viewport>
